import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import SkeletonLoader from "../../SkeletonLoader/ResumeLoader";

import { jsonEditorContext } from "../../../Context/jsonEditorContext";

import AsyncSelect from "../../AsyncSelect/AsyncSelect";
import axios from "axios";
import ResumeUseForm from "../../../hooks/editor/resumeUseForm";

import "./SampleCoverContentModal.scss";
import {
  resumeEditActions,
  getResumeById,
} from "../../../Store/Actions/ResumeActions";
import {
  coverEditActions,
  getCoverById,
  sampleCoverById,
} from "../../../Store/Actions/CoverLetterActions";
import { ResumeUpdateContext } from "../../../Context/resumeUpdateContext";
import { useElements } from "@stripe/react-stripe-js";
import { JsonEditorContextProvider } from "../../../Context/jsonEditorContext";
import SampleItem from "./SampleCoverItem";
import LoginPopup from "../LoginPopup/LoginPopup";
import { coverTemplateGetParticularActions } from "../../../Store/Actions/TemplateActions";

import { updateLocal } from "../../../Utils/updateLocalStorage";
import {
  COVER_DATA_ADD,
  COVER_DATA_RESET,
} from "../../../Store/Constants/EditorConstants";
function SampleResume(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const query = new URLSearchParams(window.location.search);
  const job = query.get("job");
  //   const jobId = query.get("id");
  const path = window.location.pathname;
  const [showLogin, setShowLogin] = useState(false);

  const experience = query.get("exp");
  const [nextUrl, setNextUrl] = useState("");
  const baseUrl = process.env.REACT_APP_API_URL;
  const [selected, setSelected] = useState(0);
  const [content, setContent] = useState("");
  const [sampleJobTitle, setSampleJobTitle] = useState("");
  const [template, setTemplate] = useState("");
  const [clickedTemplate, setClickedTemplate] = useState({ id: 3 });
  const { preview, setPreview } = useContext(ResumePopupContext);
  //Local States
  const [exp, setExp] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [sampleContent, setSampleContent] = useState([]);
  const [sampleData, setSampleData] = useState();

  //Redux Store Values
  const experienceData = useSelector((state) => state.getExperience.experience);
  const templateData = useSelector((state) => state.CoverTemplates.list);

  const userData = useSelector((state) => state.userData.userInfo);
  const loadSampleData = useSelector((state) => state.coverSampleList.sample);
  const editorData = useSelector((state) => state.coverData);
  const { coverLetter } = useSelector((state) => state.coverParticular);
  // const { layoutHandler } = ResumeUseForm("profile");

  const {
    coverJson,
    setCoverJson,
    isCoverJson,
    setIsCoverJson,
    isCoverSample,
    setIsCoverSample,
    jsonCoverIndex,
    setJsonCoverIndex,
  } = useContext(jsonEditorContext);

  const chooseSample = (image, selectId, content, randomTemplate, res) => {
    setSampleJobTitle(res.job_title);
    setSelected(selectId);
    setContent(content);
    setClickedTemplate(randomTemplate && randomTemplate);
    setSampleData(res);
  };

  const handleSampleContent = (type) => {
    const user_settings = {
      job_title: sampleData && sampleData.job_title,
      job_category: sampleData && sampleData.category,
    };
    updateLocal(user_settings);
    if (path && path.includes("create")) {
      setIsCoverSample(false);
      setPreview(false);
      setIsCoverJson(false);
      let cont = JSON.parse(content);
      let data = { ...props.resumeFields };
      //   data["experience"]["data"] = cont.experience.data;
      //   data["summary"]["data"] = cont.summary.data;
      //   data["skills"]["data"] = cont.skills.data;
      data["from"].jobTitle = sampleJobTitle;
      data["content"] = cont.content;
      if (type && type == "template") {
        data["editorSettings"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.editorSettings;
        data["customization"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.customization;
        data["from"]["jobTitle"] = cont.from.jobTitle;
        // let tempData = coverLetter;
        // tempData["content"] = data;
        data["template_id"] = clickedTemplate && clickedTemplate.id;
        dispatch(
          coverTemplateGetParticularActions(
            clickedTemplate && clickedTemplate.id
          )
        );

        //Handle Premium
        const checkLockedFeature =
          data["lockedFeatures"] === undefined ? false : true;
        if (!checkLockedFeature) {
          data["lockedFeatures"] = [];
        }
        const objWithIdIndex =
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].findIndex((obj) => obj === "template");
        // let res = { ...editorData }
        if (clickedTemplate && clickedTemplate.usage == "2") {
          if (objWithIdIndex === -1) {
            data["lockedFeatures"].push("template");
          }
        } else {
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
        }
      }
      props.setResumeFields(data);
      dispatch({
        type: COVER_DATA_ADD,
        payload: data,
      });
      dispatch(sampleCoverById(id, data, "isAuth"));

      hideSample(true);
    } else {
      setIsCoverSample(false);
      setIsCoverJson(false);
      setSelected(0);

      let cont = JSON.parse(content);

      let data = { ...props.resumeFields };
      //   data["experience"]["data"] = cont.experience.data;
      //   data["summary"]["data"] = cont.summary.data;
      data["content"] = cont.content;
      data["from"]["jobTitle"] = sampleJobTitle;
      if (type && type == "template") {
        data["editorSettings"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.editorSettings;
        data["customization"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.customization;

        //Handle Premium
        const checkLockedFeature =
          data["lockedFeatures"] === undefined ? false : true;
        if (!checkLockedFeature) {
          data["lockedFeatures"] = [];
        }
        const objWithIdIndex =
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].findIndex((obj) => obj === "template");
        // let res = { ...editorData }
        if (clickedTemplate && clickedTemplate.usage == "2") {
          if (objWithIdIndex === -1) {
            data["lockedFeatures"].push("template");
          }
        } else {
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
        }
      }
      setPreview(false);
      dispatch({
        type: COVER_DATA_RESET,
        payload: {},
      });

      props.setResumeFields(data);

      const body = {
        title: coverLetter && coverLetter.title,
        body: "Body",
        content: JSON.stringify(data),
        completed: false,
        isLetter: coverLetter && coverLetter.isLetter,
        type: "cover_letter",
        template_id:
          type == "content"
            ? coverLetter && coverLetter.template_id
            : clickedTemplate && clickedTemplate.id,
      };
      dispatch(coverEditActions(id, body)).then((response) => {
        dispatch(getCoverById(id)).then(() => {});
      });
      hideSample();
    }
  };

  useEffect(() => {
    setSampleContent(
      loadSampleData && loadSampleData.data && loadSampleData.data
    );
    setContent(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].content
    );
    setSampleJobTitle(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].job_title
    );
    setSelected(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].id
    );
  }, [loadSampleData]);

  useEffect(() => {
    if (templateData && templateData && templateData.length > 0) {
      let tempArray = [];
      templateData &&
        templateData &&
        templateData
          .filter((data) => data.status == "1")
          .map((data, index) => {
            tempArray.push(data);
            if (index == 0) {
              setClickedTemplate(data);
            }
          });

      setTemplate(tempArray);
    }
  }, [templateData]);

  //Hide Modal
  const hideSample = () => {
    setIsCoverSample(false);
    setPreview(false);
    setIsCoverJson(false);
    props.hideSample(true);
  };

  useEffect(() => {
    if (props && props.showSample) {
      setIsCoverSample(true);
    }
  }, [props.showSample]);

  const handleHide = () => {
    setShowLogin(false);
  };
  let i = 0;

  return (
    <>
      <Modal
        className="sample-resume-modal "
        show={props.showSample}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onEscapeKeyDown={hideSample}
      >
        <Modal.Body className="sample-resume-modal-body">
          <LoginPopup show={showLogin} hide={handleHide} />
          <img
            onClick={() => hideSample()}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close sample-coverpreview-smallclose"
          />
          <div className=" d-flex flex-wrap">
            <div className="samplecover-modal-listdiv">
              <div className="sample_img_section">
                <div>
                  <h4 style={{ color: "#ffffff" }}>
                    Import a Cover Letter Sample
                  </h4>
                </div>
                <div className="frmgrp">
                  <span style={{ fontSize: "13px", color: "#ffffff" }}>
                    Job Title:
                  </span>
                  <AsyncSelect
                    setSelectedValue={setSelectedValue}
                    job={job}
                    modal={props.showSample}
                    cover={"cover"}
                  />
                  {loadSampleData &&
                    !loadSampleData.success &&
                    loadSampleData &&
                    loadSampleData.message && (
                      <span className="error">
                        Job title not available choose another one
                      </span>
                    )}
                </div>
                <div className="sample_exp_select_div mt-3">
                  <div
                    id="scrollableDiv"
                    className="row sample-cover-visual-div"
                  >
                    {sampleContent &&
                      template &&
                      template.length > 0 &&
                      sampleContent.map((res, index) => {
                        let image = res.thumb;

                        let template_id = template && template[i];
                        let contentId = i;
                        if (i >= template.length - 1) {
                          i = 0;
                        } else {
                          i++;
                        }
                        let template_image = JSON.parse(
                          template_id && template_id.image
                        );
                        return (
                          <>
                            <JsonEditorContextProvider>
                              {selected === res.id ? (
                                <>
                                  <div
                                    className="sample_cover_img_modal_div"
                                    style={{ position: "relative" }}
                                    onClick={() =>
                                      chooseSample(
                                        image,
                                        res.id,
                                        res.content,
                                        template_id,
                                        res
                                      )
                                    }
                                  >
                                    <div style={{ pointerEvents: "none" }}>
                                      {/* <SampleItem
                                        resumedata={res.content}
                                        index={index}
                                        randomTemplate={template_id}
                                      /> */}
                                      <div className="sample_cover_img_modal ">
                                        <img
                                          className="template-image w-100"
                                          src={
                                            template_image && template_image.key
                                          }
                                        />
                                      </div>
                                    </div>

                                    <p style={{ color: "#ffffff" }}>
                                      {res.title}
                                    </p>
                                    <div className="mobile-coverpreview-edit">
                                      <button
                                        className="btn btn-success mb-2"
                                        onClick={() =>
                                          handleSampleContent("content")
                                        }
                                      >
                                        With Content only
                                      </button>
                                      <button
                                        className="btn btn-success"
                                        onClick={() =>
                                          handleSampleContent("template")
                                        }
                                      >
                                        With Template
                                      </button>
                                    </div>
                                    <div className="checkcircle-sample">
                                      <img
                                        src="/images/checkwhite.svg"
                                        alt="checkwhite"
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="sample_cover_img_modal_div"
                                    onClick={() =>
                                      chooseSample(
                                        image,
                                        res.id,
                                        res.content,
                                        template_id,
                                        res
                                      )
                                    }
                                  >
                                    <div style={{ pointerEvents: "none" }}>
                                      {/* <SampleItem
                                        resumedata={res.content}
                                        index={index}
                                        randomTemplate={template_id}
                                      /> */}
                                      <div className="sample_cover_img_modal  ">
                                        <img
                                          className="template-image w-100"
                                          src={
                                            template_id &&
                                            template_id.sample_image
                                          }
                                        />
                                      </div>
                                    </div>

                                    {/* <img
                                        className="sample_cover_img_modal mb-3"
                                        src={res.thumb}
                                        onClick={() =>
                                          chooseSample(
                                            image,
                                            res.id,
                                            res.content
                                          )
                                        }
                                      /> */}
                                    <p style={{ color: "#ffffff" }}>
                                      {res.title}
                                    </p>
                                  </div>
                                </>
                              )}
                            </JsonEditorContextProvider>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            <div className="samplecover-modal-previewdiv ">
              <div className="sample-cover-selected-img-div">
                <div className="sample_preview_image">
                  <div>
                    {template &&
                    template.length > 0 &&
                    sampleContent &&
                    sampleContent ? (
                      sampleContent.map((res, index) => {
                        return (
                          <>
                            <JsonEditorContextProvider>
                              {selected == res.id ? (
                                <>
                                  <SampleItem
                                    resumedata={res.content}
                                    index={index}
                                    randomTemplate={clickedTemplate}
                                    full
                                    job_title={res.job_title}
                                  />
                                </>
                              ) : (
                                ""
                              )}
                            </JsonEditorContextProvider>
                          </>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          width: "799px",
                          height: "1122px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <SkeletonLoader count={5} />
                      </div>
                    )}
                  </div>

                  <div className=" sample-use-box">
                    <div className="row">
                      <div className="col-md-6">
                        <h5
                          className="card-title text-center "
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSampleContent("content")}
                        >
                          <i className="fas fa-check pr-3"></i>
                          Use Content Only.
                        </h5>
                      </div>
                      <div className="col-md-6">
                        <h5
                          className="card-title text-center "
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSampleContent("template")}
                        >
                          <i className="fas fa-check pr-3"></i>
                          Use Content & Template.
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="close-div sample-coverpreview-large-close">
                    <img
                      src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                      alt="closeicon"
                      className="sample-selected-close"
                      onClick={hideSample}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SampleResume;
